import { OcrResult } from "@finway-group/shared/lib/models"
import { roundNumberTo2Decimals } from "@finway-group/shared/lib/utils"
import { Col, Row } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { SectionHeader, TableHeader } from "./shared"

interface VatBreakdownProps {
    data: OcrResult
}

export const EInvoiceVatBreakdown = ({ data }: VatBreakdownProps) => {
    const { t } = useTranslation()
    if (!data.eInvoiceData?.taxSubtotals) {
        return null
    }

    return (
        <>
            <SectionHeader title={t("label:vat_breakdown")} />
            <TableHeader
                columns={[
                    { span: 6, label: t("label:category") },
                    { span: 8, label: t("label:tax_base_amount") },
                    { span: 4, label: t("label:vat_rate") },
                    { span: 6, label: t("label:tax_amount"), textAlign: "right" },
                ]}
            />
            <div className="border-1 border-gray-200 font-medium text-xs space-y-8 rounded-sm">
                {data.eInvoiceData.taxSubtotals.map((taxSubtotal: any, index: number) => (
                    <Row
                        key={taxSubtotal.taxableAmount}
                        className={`p-10 px-14 text-black ${index !== data.eInvoiceData!.invoiceLines.length - 1 ? "border-b-1 border-gray-200" : ""}`}
                    >
                        <Col span={6}>
                            <span>
                                {taxSubtotal.taxCategoryTaxScheme} {taxSubtotal.taxCategoryId?.replace("TAX_CATEGORY_CODE_", "")}
                            </span>
                        </Col>
                        <Col span={8}>
                            <span>{roundNumberTo2Decimals(taxSubtotal.taxableAmount)}</span>
                        </Col>
                        <Col span={4}>
                            <span>{taxSubtotal.taxCategoryPercent}%</span>
                        </Col>
                        <Col span={6} className="text-right">
                            <span>{roundNumberTo2Decimals(taxSubtotal.taxAmount)}</span>
                        </Col>
                    </Row>
                ))}
            </div>
        </>
    )
}
